import { render } from "./matrices_attractiveness.vue?vue&type=template&id=1f4ad0be&scoped=true"
import script from "./matrices_attractiveness.vue?vue&type=script&lang=js"
export * from "./matrices_attractiveness.vue?vue&type=script&lang=js"

import "./matrices_attractiveness.vue?vue&type=style&index=0&id=1f4ad0be&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4ad0be"]])

export default __exports__